<!--
 * @Description: 提货区域地址新增编辑弹出层
 * @Author: Auto
 * @Date: 2026-01-26
 -->
<template>
  <el-dialog :title="isEdit ? '编辑提货区域地址' : '新增提货区域地址'" :visible.sync="visible" @close="handleClose" width="600px">
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item label="提货区域" prop="takeAreaId">
        <el-select v-model="form.takeAreaId" placeholder="请选择提货区域" clearable filterable @change="handleTakeAreaChange">
          <el-option
            v-for="item in takeAreaOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="省市区" prop="region">
        <el-cascader
          :options="regionOptions"
          v-model="form.region"
          :props="cascaderProps"
          clearable
          placeholder="请选择省市区"
          @change="handleRegionChange">
        </el-cascader>
      </el-form-item>
      <el-form-item label="详细地址" prop="address">
        <el-input v-model="form.address" placeholder="请输入详细地址" maxlength="200"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择状态">
          <el-option
            v-for="item in statusArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="save">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'addOrEditDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default () {
        return {}
      }
    },
    takeAreaOptions: {
      type: Array,
      default () {
        return []
      }
    },
    regionOptions: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      visible: this.show,
      isEdit: false,
      form: {
        id: '',
        takeAreaId: '',
        takeAreaName: '',
        region: [],
        proviceCode: '',
        proviceName: '',
        cityCode: '',
        cityName: '',
        areaCode: '',
        areaName: '',
        address: '',
        status: 0
      },
      cascaderProps: {
        value: 'code',
        label: 'name',
        children: 'children'
      },
      statusArr: [
        {
          value: 0,
          label: '生效中'
        },
        {
          value: 1,
          label: '已失效'
        }
      ],
      rules: {
        takeAreaId: [
          { required: true, message: '请选择提货区域', trigger: 'change' }
        ],
        region: [
          { required: true, message: '请选择省市区', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        this.initForm()
      }
    }
  },
  methods: {
    // 初始化表单
    initForm () {
      if (this.info && this.info.id) {
        // 编辑模式
        this.isEdit = true
        this.form = {
          id: this.info.id,
          takeAreaId: this.info.takeAreaId,
          takeAreaName: this.info.takeAreaName,
          region: this.getRegionCodes(),
          proviceCode: this.info.proviceCode,
          proviceName: this.info.proviceName,
          cityCode: this.info.cityCode,
          cityName: this.info.cityName,
          areaCode: this.info.areaCode,
          areaName: this.info.areaName,
          address: this.info.address,
          status: this.info.status
        }
      } else {
        // 新增模式
        this.isEdit = false
        this.form = {
          id: '',
          takeAreaId: '',
          takeAreaName: '',
          region: [],
          proviceCode: '',
          proviceName: '',
          cityCode: '',
          cityName: '',
          areaCode: '',
          areaName: '',
          address: '',
          status: 0
        }
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    // 获取省市区编码数组
    getRegionCodes () {
      if (this.info.proviceCode && this.info.cityCode && this.info.areaCode) {
        return [this.info.proviceCode, this.info.cityCode, this.info.areaCode]
      } else if (this.info.proviceCode && this.info.cityCode) {
        return [this.info.proviceCode, this.info.cityCode]
      } else if (this.info.proviceCode) {
        return [this.info.proviceCode]
      }
      return []
    },
    // 提货区域选择变化
    handleTakeAreaChange (val) {
      const selectedArea = this.takeAreaOptions.find(item => item.id === val)
      if (selectedArea) {
        this.form.takeAreaName = selectedArea.name
      }
    },
    // 省市区选择变化
    handleRegionChange (val) {
      if (val && val.length > 0) {
        this.updateRegionInfo(val)
      } else {
        this.form.proviceCode = ''
        this.form.proviceName = ''
        this.form.cityCode = ''
        this.form.cityName = ''
        this.form.areaCode = ''
        this.form.areaName = ''
      }
    },
    // 更新省市区信息
    updateRegionInfo (regionCodes) {
      for (let i = 0; i < this.regionOptions.length; i++) {
        const province = this.regionOptions[i]
        if (province.code === regionCodes[0]) {
          this.form.proviceCode = province.code
          this.form.proviceName = province.name
          if (regionCodes.length > 1 && province.children) {
            for (let j = 0; j < province.children.length; j++) {
              const city = province.children[j]
              if (city.code === regionCodes[1]) {
                this.form.cityCode = city.code
                this.form.cityName = city.name
                if (regionCodes.length > 2 && city.children) {
                  for (let k = 0; k < city.children.length; k++) {
                    const area = city.children[k]
                    if (area.code === regionCodes[2]) {
                      this.form.areaCode = area.code
                      this.form.areaName = area.name
                      break
                    }
                  }
                }
                break
              }
            }
          }
          break
        }
      }
    },
    // 关闭
    handleClose () {
      this.$emit('update:show', false)
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    // 保存
    save () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 确保提货区域名称已设置
          if (!this.form.takeAreaName) {
            const selectedArea = this.takeAreaOptions.find(item => item.id === this.form.takeAreaId)
            if (selectedArea) {
              this.form.takeAreaName = selectedArea.name
            }
          }
          // 确保省市区信息已设置
          if (this.form.region && this.form.region.length > 0) {
            this.updateRegionInfo(this.form.region)
          }
          this.$emit('save', { ...this.form })
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
